import React from "react";

function PrivacyPolicy() {
  return <div>PrivacyPolicy</div>;
}

export default PrivacyPolicy;
